/* Pawro — FAQ help center engine (theme asset, loaded deferred by
   sections/pawro-faq.liquid). Live search over questions AND answers with
   <mark> highlighting and an empty state, exclusive accordion behavior,
   and sidebar scroll-spy. No libraries; transform/opacity-friendly (all
   show/hide goes through [hidden] + CSS animation classes). */
(function () {
  if (window.__pawroFaq) return;
  window.__pawroFaq = true;

  function init() {
    var root = document.querySelector('[data-faq]');
    if (!root) return;

    var input = root.querySelector('[data-faq-input]');
    var clearBtn = root.querySelector('[data-faq-clear]');
    var empty = root.querySelector('[data-faq-empty]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav]'));

    items.forEach(function (item) {
      item.__q = item.querySelector('[data-faq-q]');
      item.__a = item.querySelector('[data-faq-a]');
      var qText = item.__q ? item.__q.textContent : '';
      var aText = item.__a ? item.__a.textContent : '';
      item.__text = (qText + ' ' + aText).toLowerCase();
    });

    /* ---------- exclusive accordion (works in every browser) ---------- */
    root.addEventListener('toggle', function (event) {
      var opened = event.target;
      if (!opened.hasAttribute || !opened.hasAttribute('data-faq-item') || !opened.open) return;
      if (root.classList.contains('faq-searching')) return; /* search may open several */
      items.forEach(function (other) {
        if (other !== opened && other.open) other.open = false;
      });
    }, true);

    /* ---------- search ---------- */
    function clearMarks(el) {
      if (!el) return;
      Array.prototype.slice.call(el.querySelectorAll('mark[data-faq-mark]')).forEach(function (mark) {
        var parent = mark.parentNode;
        parent.replaceChild(document.createTextNode(mark.textContent), mark);
        parent.normalize();
      });
    }

    function markMatches(el, query) {
      if (!el) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var text = node.nodeValue;
        var lower = text.toLowerCase();
        var index = lower.indexOf(query);
        if (index === -1) return;
        var frag = document.createDocumentFragment();
        var pos = 0;
        while (index !== -1) {
          frag.appendChild(document.createTextNode(text.slice(pos, index)));
          var mark = document.createElement('mark');
          mark.setAttribute('data-faq-mark', '');
          mark.textContent = text.slice(index, index + query.length);
          frag.appendChild(mark);
          pos = index + query.length;
          index = lower.indexOf(query, pos);
        }
        frag.appendChild(document.createTextNode(text.slice(pos)));
        node.parentNode.replaceChild(frag, node);
      });
    }

    function applyFilter(raw) {
      var query = (raw || '').trim().toLowerCase();
      var searching = query.length > 0;
      root.classList.toggle('faq-searching', searching);
      if (clearBtn) clearBtn.hidden = !searching;

      var anyHit = false;
      var opened = 0;
      items.forEach(function (item) {
        clearMarks(item.__q);
        clearMarks(item.__a);
        var hit = !searching || item.__text.indexOf(query) !== -1;
        item.hidden = !hit;
        if (hit && searching) {
          markMatches(item.__q, query);
          markMatches(item.__a, query);
          /* open the first few matches so highlighted answers are visible */
          item.open = opened < 3;
          opened += 1;
        } else if (!searching) {
          item.open = false;
        }
        if (hit) anyHit = true;
      });

      groups.forEach(function (group) {
        var visible = group.querySelectorAll('[data-faq-item]:not([hidden])').length;
        group.hidden = visible === 0;
      });
      navLinks.forEach(function (link) {
        var group = document.getElementById(link.getAttribute('data-faq-nav'));
        var wrapper = link.closest('li') || link;
        wrapper.hidden = !group || group.hidden;
      });
      if (empty) empty.hidden = anyHit;
    }

    if (input) {
      var timer = null;
      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { applyFilter(input.value); }, 120);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value) {
          input.value = '';
          applyFilter('');
        }
      });
      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          applyFilter(input.value);
        });
      }
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) {
          input.value = '';
          input.focus();
        }
        applyFilter('');
      });
    }
    Array.prototype.slice.call(root.querySelectorAll('[data-faq-reset]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (input) {
          input.value = '';
          input.focus();
        }
        applyFilter('');
      });
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-faq-chip]')).forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!input) return;
        input.value = chip.getAttribute('data-faq-chip') || chip.textContent.trim();
        input.focus();
        applyFilter(input.value);
      });
    });

    /* ---------- scroll spy ---------- */
    if ('IntersectionObserver' in window && groups.length && navLinks.length) {
      var setActive = function (id) {
        navLinks.forEach(function (link) {
          var active = link.getAttribute('data-faq-nav') === id;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });
      groups.forEach(function (group) { spy.observe(group); });
      setActive(groups[0].id);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
